import { makeStyles, Theme, createStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {
        display: 'flex',
        gap: 48,
        [theme.breakpoints.down('sm')]: {
            gap: 20
        }
    }
  }),
)
